import { combineReducers } from 'redux';
import userContextReducer from './contextReducer';
import userInfoReducer from './infoReducer';
/* global Redux */
const userReducer = function() {
  return combineReducers({
    context: userContextReducer,
    info: userInfoReducer,
  });
};

export default userReducer();
